/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2018 ICEMEDX, Inc.
***********************************************/
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../../login/login.service';
import { LoginConfig } from '../../login/login.config';
import { IceNavService } from './ice-nav.service';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';

@Component({
  selector: 'icenav',
  templateUrl: './ice-nav.component.html',
  styleUrls: ['./ice-nav.component.scss'],
  providers: [LoginService, IceNavService, MessageService]
})
export class IceNavComponent implements OnInit {
  @Input() brandName: string = "NetworkNow EHR";
  @Input() brandTrademark: boolean = true;

  searchOn: boolean = false;
  alertsOn: boolean = false;

  constructor(private loginSvc: LoginService, private navSvc: IceNavService, private router: Router) {
  }

  ngOnInit() {
    // toggle the nav bar style to show the menu item text on mobile devices
    if (window.innerWidth < 992) {
      document.body.classList.add("sidenav-toggled");
    }
  }

  SideNavToggle(event) {
    event.preventDefault();
    document.body.classList.toggle("sidenav-toggled");
    // Todo: Revamp this code to be more angular elegant
    var na1 = document.querySelectorAll(".navbar-sidenav .nav-link-collapse");
    for (var i = 0; i < na1.length; i++)
        na1[i].classList.add("collapsed");

    var na2 = document.querySelectorAll(".navbar-sidenav .sidenav-second-level, .navbar-sidenav .sidenav-third-level");
    for (var j = 0; j < na2.length; j++) {
      na2[j].classList.remove("show");
    }
  }

  SideNavClicked(event) {
    event.preventDefault();
    var na2 = document.querySelectorAll(".navbar-sidenav .nav-link-collapse");
    for (var j = 0; j < na2.length; j++)
        na2[j].classList.remove("sidenav-toggled");

    var na1 = document.querySelectorAll(".navbar-collapse");
    for (var j = 0; j < na1.length; j++) {
      na1[j].classList.remove("show");
    }
  }

  Logout(event) {
    if (false == this.loginSvc.SessionLogout()) {
      this.navSvc.refresh();
      this.router.navigate([LoginConfig.getFormattedPath(this.loginSvc.app_path, 'loginflow')]);
    }
  }
}
